import React, { useEffect, useRef, useState } from 'react';
import { ListSkeleton } from '../../components/UI/Skeleton/Skeleton';
import { Modal } from 'react-bootstrap';
import ConfirmDialog from '../../components/common/ConfirmDialog';
import _debounce from 'lodash/debounce';

import NoFilesFound from '../../assets/images/noFilesFound.svg';

import {
  // useUploadFileMutation,
  // useAddFilesMutation,
  useGetFileListQuery,
  useDeleteFilesMutation,
  useUploadFileS3Mutation
} from '../../redux/apis/files';
import { useIsLoggedInQuery } from '../../redux/apis/authApi';
import { useEditEmployeeMutation, useGetEmployeeByIdQuery } from '../../redux/apis/employee';

import PdfViewer from '../../components/common/PdfViewer';
import '../Admin/Files.scss';

import { GLOBAL, getRecordLocality } from '../../utils/constant/global';
import { LB_FILES } from '../../utils/constant/labels';
import { notification } from '../../utils/notification';
import { HEADER_TITLE } from '../../utils/constant/header';
import { TOAST_TYPE } from '../../utils/constant/errorMessage';
import { PLACEHOLDER } from '../../utils/constant/placeHolders';
import { BT_BUTTON_LABELS } from '../../utils/constant/buttons';
import {
  downloadFile,
  // downloadFileFromURL,
  downloadFileFromURLS3,
  // getFileIcon,
  getFileIconS3Url,
  getUserName,
  isImage
} from '../../utils/handler';
import { uploadFiles } from '../../utils/common';

const { LB_ADDED_BY } = LB_FILES;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { LOADING, NO_FILES_AVAILABLE } = GLOBAL;
const { PH_SEARCH_INPUT, PH_NO_FILES } = PLACEHOLDER;
const { DELETE_CONFIRM, DELETE_FILE } = HEADER_TITLE;
const { BTN_SAVE, BTN_CANCEL, BTN_DELETE } = BT_BUTTON_LABELS;

const DOCUMENTS = [
  { key: 'aadhaarCard', label: 'Aadhaar Card', icon: 'icofont-id-card', tone: 'indigo' },
  { key: 'panCard', label: 'PAN Card', icon: 'icofont-credit-card', tone: 'amber' },
  {
    key: 'degreeCertificate',
    label: 'Degree Certificate',
    icon: 'icofont-graduate-alt',
    tone: 'green'
  },
  { key: 'marksheet', label: '10/12th Marksheet', icon: 'icofont-paper', tone: 'sky' },
  {
    key: 'offerLetter',
    label: 'Last Company Offer Letter',
    icon: 'icofont-briefcase',
    tone: 'slate'
  },
  {
    key: 'incrementLetter',
    label: 'Increment Letter (Last Company)',
    icon: 'icofont-chart-growth',
    tone: 'rose'
  },
  {
    key: 'relievingLetter',
    label: 'Relieving Letter (Last Company)',
    icon: 'icofont-exit',
    tone: 'amber'
  },
  {
    key: 'experienceLetter',
    label: 'Experience Letter (Last Company)',
    icon: 'icofont-certificate-alt-1',
    tone: 'green'
  },
  { key: 'certification', label: 'Certification (If any)', icon: 'icofont-award', tone: 'indigo' }
];

// Utility function to clear refs
const clearRefs = (state) => {
  Object.keys(state).forEach((key) => {
    if (key.endsWith('Ref') && state[key]?.current) {
      state[key].current.value = '';
    }
  });
};

export default function EmployeeFile() {
  const initialState = {
    search: '',
    loading: false,
    files: [],
    apiData: null,
    showDeleteModal: false,
    fileToDelete: null,
    aadhaarCard: [],
    panCard: [],
    degreeCertificate: [],
    marksheet: [],
    offerLetter: [],
    incrementLetter: [],
    relievingLetter: [],
    experienceLetter: [],
    certification: [],
    aadhaarCardRef: useRef(null),
    panCardRef: useRef(null),
    degreeCertificateRef: useRef(null),
    marksheetRef: useRef(null),
    offerLetterRef: useRef(null),
    incrementLetterRef: useRef(null),
    relievingLetterRef: useRef(null),
    experienceLetterRef: useRef(null),
    certificationRef: useRef(null),
    filesRef: useRef(null)
  };

  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState({});
  const [otherFileUploadLoading, setOtherFileUploadLoading] = useState(false);
  const { data } = useIsLoggedInQuery();
  // const [upload] = useUploadFileMutation();
  const [deleteFile] = useDeleteFilesMutation();
  // const [addFile] = useAddFilesMutation();
  const [editEmployee] = useEditEmployeeMutation();
  const [uploadFileS3] = useUploadFileS3Mutation();
  const {
    data: fileListData,
    isLoading,
    isFetching,
    refetch
  } = useGetFileListQuery({
    userId: data?.data?._id,
    search: state.search
  });
  const { data: employeeInfos, refetch: employeeRefetch } = useGetEmployeeByIdQuery(
    data?.data?._id
  );

  useEffect(() => {
    refetch();
    employeeRefetch();
    // Cleanup function to reset state on unmount
    return () => {
      setState(initialState);
      clearRefs(state);
    };
  }, [data?.data?._id]);

  useEffect(() => {
    handleEmployeeData();
  }, [employeeInfos?.data]);

  const handleEmployeeData = () => {
    if (employeeInfos?.data) {
      setState((prevState) => {
        const updatedState = {};

        // Iterate through the keys in the data object
        Object.keys(employeeInfos?.data).forEach((key) => {
          // Check if the key exists in the state
          if (key in prevState) {
            updatedState[key] = employeeInfos?.data[key] || []; // Update the state with the value from data
          }
        });

        return { ...prevState, ...updatedState };
      });
    }
  };

  const setKeyLoading = (key, value = true) => {
    setLoading((prev) => ({
      ...prev,
      [key]: value
    }));
  };

  const debouncedOnSearchData = _debounce((data) => {
    setState({ ...state, search: data });
  }, 500);

  const handleDelete = (file) => {
    setState({ ...state, showDeleteModal: true, fileToDelete: file });
  };

  const handleUploadFile = (e, key) => {
    const files = Array.from(e?.target?.files);
    setState((prevState) => ({
      ...prevState,
      [key]: [...prevState[key], ...files]
    }));
  };

  /* const handleUploadDocs = async (key, index) => {
    try {
      // Extract the items from the state
      const uploadedFiles = Object.values(state[key]);

      // Initialize FormData to append files for upload
      const formData = new FormData();

      // Initialize an array to store URLs
      const urlsToStore = [];

      // Iterate over each item
      for (const item of uploadedFiles) {
        if (item instanceof File) {
          // If the item is a File, append it to FormData
          formData.append('files', item);
        } else if (typeof item === 'string') {
          // If the item is a string (URL), add it to the URLs array
          urlsToStore.push(item);
        }
      }

      // If there are files to upload, do the upload
      if (formData.has('files')) {
        try {
          const response = await upload(formData);
          if (response?.data?.success) {
            let docsUrls = response.data.data?.files?.map((d) => d?.location) || [];

            const employeeData = {
              [key]: [...urlsToStore, ...docsUrls]
            };
            await updateEmployeeFiles(employeeData);

            // notification(response?.data?.message, TOAST_SUCCESS);
          } else {
            notification(response?.data?.message, TOAST_ERROR);
          }
          // Handle response and update state if needed
        } catch (error) {
          notification(error?.message || 'Something went wrong', TOAST_ERROR);
        }
      } else {
        notification('Already saved', TOAST_SUCCESS);
      }
    } catch (error) {
      notification(error?.message || 'Something went wrong', TOAST_ERROR);
      console.error('Error uploading files:', error);
    }
  }; */

  const handleSubmitUploadS3 = async (key) => {
    try {
      setKeyLoading(key, true);
      const files = state[key]?.filter((i) => i instanceof File) || [];
      const urls = state[key]?.filter((i) => typeof i?.fileName === 'string') || [];
      const res = await uploadFiles(uploadFileS3, data?.data?._id, files);
      if (res.success) {
        const docsData = res?.data?.map((e) => e?.awsFilename) || [];
        const prevData = urls?.map((e) => e?.fileName) || [];
        const employeeData = {
          [key]: [...prevData, ...docsData]
        };

        const updaetRes = await updateEmployeeFiles(employeeData);
        if (updaetRes?.data?.success) {
          setState((prevState) => ({
            ...prevState,
            [key]: updaetRes?.data?.data[key]
          }));
        }
        if (state[`${key}Ref`]?.current) {
          state[`${key}Ref`].current.value = null;
        }
      }
      setKeyLoading(key, false);
    } catch (error) {
      setKeyLoading(key, false);
      notification(error?.message || 'Something went wrong', TOAST_ERROR);
    }
  };

  const updateEmployeeFiles = async (employeeData) => {
    const locality = getRecordLocality(employeeInfos?.data || data?.data);
    const res = await editEmployee({
      data: {
        ...employeeData,
        ...(locality.length ? { locality } : {})
      },
      id: data?.data?._id
    });

    if (res?.data?.success) {
      notification(res.data.statusMessage, TOAST_SUCCESS);
      return res;
    }

    const errorMessage =
      res?.error?.data?.statusMessage || res?.data?.statusMessage || 'Something went wrong';
    notification(errorMessage, TOAST_ERROR);
    return res;
  };

  const renderPreview = (files, key) => {
    const [showModals, setShowModals] = useState(Array(files?.length || 0).fill(false));

    // Create object URLs for File objects
    const fileURLs = files?.map((file) =>
      file instanceof File ? URL.createObjectURL(file) : file?.fileUrl
    );

    // Cleanup object URLs on component unmount or files change
    useEffect(() => {
      return () => {
        fileURLs?.forEach((fileURL) => {
          if (fileURL && fileURL.startsWith('blob:')) {
            URL.revokeObjectURL(fileURL);
          }
        });
      };
    }, [fileURLs]);

    const openModal = (index) => {
      setShowModals((prev) => {
        const updated = [...prev];
        updated[index] = true;
        return updated;
      });
    };

    const closeModal = (index) => {
      setShowModals((prev) => {
        const updated = [...prev];
        updated[index] = false;
        return updated;
      });
    };

    // const onCloseIconButton = (index) => {
    //   console.log("🚀 ~ onCloseIconButton ~ index:", index)
    //   setState((prevState) => {
    //     const updatedFiles = prevState[key].filter((_, i) => i !== index);
    //     console.log("🚀 ~ onCloseIconButton ~ updatedFiles:", updatedFiles)
    //     console.log('key', key);

    //     return { ...prevState, [key]: updatedFiles };
    //   });

    //   if (state[`${key}Ref`]?.current) {
    //     state[`${key}Ref`].current.value = '';
    //   }

    //   const employeeData = {
    //     [key]: []
    //   };
    //   updateEmployeeFiles(employeeData);
    // };

    // const onCloseIconButton = (index) => {
    //   setState((prevState) => {
    //     const updatedFiles = prevState[key]?.filter((_, i) => i !== index);
    //     const employeeData = {
    //       [key]: updatedFiles?.map((e) => e?.fileName)
    //     };
    //     updateEmployeeFiles(employeeData);

    //     return { ...prevState, [key]: updatedFiles };
    //   });

    //   if (state[`${key}Ref`]?.current) {
    //     state[`${key}Ref`].current.value = '';
    //   }
    // };

    const onCloseIconButton = (index) => {
      setState((prevState) => {
        const updatedFiles = prevState[key]?.filter((_, i) => i !== index);
        const removedItem = prevState[key]?.[index];
        if (!(removedItem instanceof File)) {
          const employeeData = {
            [key]: updatedFiles?.map((e) => e?.fileName)
          };
          updateEmployeeFiles(employeeData);
        }

        return { ...prevState, [key]: updatedFiles };
      });

      if (state[`${key}Ref`]?.current) {
        state[`${key}Ref`].current.value = '';
      }
    };

    if (!files || files.length === 0) return null;

    const previewParentContainerStyle = {
      width: '72px',
      height: '72px'
    };

    const previewContainerStyle = {
      border: '1px solid #e6eaf2',
      borderRadius: '12px',
      width: '72px',
      height: '72px',
      background: '#f6f7fb',
      position: 'relative',
      cursor: 'pointer',
      overflow: 'hidden',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    };

    const previewStyle = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0
    };

    /* const fileNameStyle = {
      fontSize: '12px',
      color: 'black',
      textAlign: 'center',
      marginTop: '5px',
      wordBreak: 'break-word',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '80px'
    }; */

    return (
      <div className="emp-files__previews">
        {(files ?? []).map((file, index) => {
          const fileURL = fileURLs[index];
          const isPdf =
            typeof file?.fileName === 'string' &&
            file?.fileUrl?.split('?')[0]?.toLowerCase()?.endsWith('.pdf');
          const fileName =
            file instanceof File
              ? file.name
              : typeof file?.fileName === 'string'
                ? file?.fileName?.split('/')?.pop()
                : '';

          return (
            <div key={index} style={previewParentContainerStyle}>
              <div className="preview-container" style={previewContainerStyle}>
                {/* Small Preview */}
                {file instanceof File ? (
                  file.type.startsWith('image/') ? (
                    <img
                      src={fileURL}
                      alt="Small Preview"
                      style={previewStyle}
                      onClick={() => openModal(index)}
                    />
                  ) : file.type === 'application/pdf' ? (
                    // <iframe src={fileURL} title="PDF Preview" style={previewStyle} />
                    <i
                      className="icofont-file-pdf"
                      style={{ fontSize: '24px', color: '#ff0000', cursor: 'pointer' }}
                      title="View PDF"
                    ></i>
                  ) : (
                    <p className="text-muted">No Preview Available</p>
                  )
                ) : typeof file?.fileName === 'string' && file?.fileUrl?.startsWith('http') ? (
                  isPdf ? (
                    // <a href={fileURL} target="_blank" rel="noopener noreferrer">
                    <i
                      className="icofont-file-pdf"
                      style={{ fontSize: '24px', color: '#ff0000', cursor: 'pointer' }}
                      title="View PDF"
                    ></i>
                  ) : (
                    // </a>
                    // <iframe src={fileURL} title="PDF URL Preview" style={previewStyle} />
                    <img
                      src={fileURL}
                      alt="URL Preview"
                      style={previewStyle}
                      onClick={() => openModal(index)}
                    />
                  )
                ) : (
                  <p className="text-muted">No Preview Available</p>
                )}

                {/* Centered Overlay with Icons */}
                <div className="icon-overlay">
                  <button
                    className="icon-btn view-btn"
                    title="View"
                    onClick={() => openModal(index)}
                  >
                    <i className="icofont-eye"></i>
                  </button>
                  {typeof file?.fileName === 'string' && (
                    <button
                      type="button"
                      title="Download"
                      className="icon-btn view-btn"
                      onClick={() => downloadFileFromURLS3(fileURL, fileName)}
                    >
                      <i className="icofont-download"></i>
                    </button>
                  )}
                  <button
                    className="icon-btn delete-btn"
                    title="Delete"
                    onClick={() => onCloseIconButton(index)}
                  >
                    <i className="icofont-close"></i>
                  </button>
                </div>

                {/* Modal for Enlarged View */}
                <Modal
                  show={showModals[index]}
                  dialogClassName="modal-lg"
                  contentClassName="modal-content-fullscreen"
                  onHide={() => closeModal(index)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>File Preview</Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ textAlign: 'center', maxHeight: '80vh', overflowY: 'auto' }}>
                    {file instanceof File ? (
                      file.type.startsWith('image/') ? (
                        <img
                          src={fileURL}
                          alt="Large Preview"
                          style={{ width: '100%', height: 'auto' }}
                        />
                      ) : file.type === 'application/pdf' ? (
                        <iframe
                          src={fileURL}
                          title="Large PDF Preview"
                          style={{ width: '100%', height: '100%' }}
                        />
                      ) : (
                        <p className="text-muted">No Preview Available</p>
                      )
                    ) : typeof file?.fileName === 'string' && file?.fileUrl?.startsWith('http') ? (
                      isPdf ? (
                        <PdfViewer url={fileURL} />
                      ) : (
                        <img
                          src={fileURL}
                          alt="Large URL Preview"
                          style={{ width: '100%', height: 'auto' }}
                        />
                      )
                    ) : (
                      <p className="text-muted">No Preview Available</p>
                    )}
                  </Modal.Body>
                </Modal>
              </div>
              {/* File Name Below Preview */}
              {/* <p
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title={fileName}
                style={fileNameStyle}
              >
                {fileName}
              </p> */}
            </div>
          );
        })}
      </div>
    );
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await deleteFile({
        fileId: state.fileToDelete,
        userId: data?.data?._id
      });
      setState({ ...state, showDeleteModal: false });
      refetch();
      notification(response?.data?.message, TOAST_SUCCESS);
    } catch (error) {
      console.error('Error deleting file:', error);
      setState({ ...state, showDeleteModal: false });
    }
  };

  const handleCancelDelete = () => {
    setState({ ...state, showDeleteModal: false });
  };

  /* const handleUpload = async (event) => {
    try {
      const uploadedFiles = Object.values(event.target.files);
      const formData = new FormData();

      for (const file of uploadedFiles) {
        formData.append('files', file);
      }
      const response = await upload(formData);

      if (response?.data?.success) {
        const updatedFiles = response.data.data.files.map((file) => ({
          name: file.originalname,
          size: file.size,
          type: file.mimetype,
          location: file.location
        }));
        setState((prevState) => ({
          ...prevState,
          files: [...prevState.files, ...updatedFiles]
        }));
        notification(response?.data?.message, TOAST_SUCCESS);
      } else {
        console.error('Upload failed:', response?.data?.message);
      }
    } catch (error) {
      console.error('Error uploading files:', error);
    }
  }; */

  // const handleSave = async () => {
  //   try {
  //     const hrxFilesPayload = state.files.map((file) => ({
  //       createdBy: data.data._id,
  //       // url: file.location,
  //       fileName: file.name,
  //       mimeType: file.type,
  //       date: Date.now(),
  //       size: file.size
  //     }));

  //     const payload = {
  //       // userId: data?.data?._id,
  //       hrxFiles: hrxFilesPayload
  //     };

  //     const files = state?.files?.filter(i => i instanceof File) || [];
  //     const urls = state.files?.filter(i => typeof i?.fileName === "string") || [];
  //     const res = await uploadFiles(uploadFileS3, data?.data?._id, files)
  //     // const response = await addFile(payload);
  //     if (res.success) {
  //       const docsData = res?.data?.map((e) => e) || []

  //       const hrxFilesPayload = res?.data?.map.map((file) => ({
  //       createdBy: data.data._id,
  //       // url: file.location,
  //       fileName: file.fileName,
  //       mimeType: file.type,
  //       date: Date.now(),
  //       size: file.size
  //     }));

  //       const prevData = urls?.map((e) => e) || []
  //       const employeeData = {
  //         hrxFiles: [...hrxFilesPayload, ...docsData]
  //       };
  //       await updateEmployeeFiles(employeeData);
  //       // setState({ ...state, files: [] });
  //       refetch();
  //       notification(res?.data?.message, TOAST_SUCCESS);
  //     }
  //   } catch (error) {
  //     console.error('Error saving files:', error);
  //   }
  // };

  const handleSave = async () => {
    try {
      setOtherFileUploadLoading(true);
      // Separate new files vs already uploaded files
      const newFiles = state?.files?.filter((f) => f instanceof File) || [];
      // const existingFilesRaw = state?.files?.filter((f) => typeof f?.fileName === "string") || [];
      const existingFilesRaw =
        fileListData?.data?.flatMap((item) =>
          (item?.hrxFiles || []).filter((f) => typeof f?.fileName === 'string')
        ) || [];

      let uploadedFiles = [];
      if (newFiles?.length > 0) {
        const res = await uploadFiles(uploadFileS3, data?.data?._id, newFiles);
        if (!res?.success) {
          notification('File upload failed', TOAST_ERROR);
          return;
        }
        setState({ ...state, files: [] });
        uploadedFiles = Array.isArray(res?.data)
          ? res.data.map((file) => ({
              createdBy: data?.data?._id,
              url: file?.awsFilename,
              fileName: file?.awsFilename?.split('/')?.pop(),
              mimeType: file?.mimeType,
              date: Date.now(),
              size: file?.size
            }))
          : [];
      }

      // Format existing files in same structure
      const existingFiles = Array.isArray(existingFilesRaw)
        ? existingFilesRaw.map((file) => ({
            createdBy: data?.data?._id,
            fileName: file?.fileName,
            url: file?.fileName,
            mimeType: file?.mimeType || file?.type,
            date: file?.date || Date.now(),
            size: file?.size
          }))
        : [];

      // Merge both sets
      const employeeData = {
        hrxFiles: [...existingFiles, ...uploadedFiles]
      };

      await updateEmployeeFiles(employeeData);
      if (state[`filesRef`]?.current) {
        state[`filesRef`].current.value = null;
      }
      refetch();

      setOtherFileUploadLoading(false);
      // notification("Files saved successfully", TOAST_SUCCESS);

      // Optionally clear files after save
    } catch (error) {
      setOtherFileUploadLoading(false);
      console.error('Error saving files:', error);
      notification('Error saving files', TOAST_ERROR);
    }
  };

  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // function getFileIcon(file) {
  //   const extension = file?.mimeType?.split('/')[1];
  //   return <FileIcon size={48} extension={extension} defaultStyles={[extension]} />;
  // }

  const employeeName = getUserName(data?.data) || data?.data?.email || '';
  const initials = (employeeName || 'E')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
  const documentsOnFile = DOCUMENTS.filter((doc) =>
    (state[doc.key] || []).some((item) => !(item instanceof File))
  ).length;
  const otherPending = (state.files || []).filter((file) => file instanceof File);

  return (
    <>
      <div className="emp-files container-xxl">
        <header className="emp-files__hero">
          <div className="emp-files__who">
            {data?.data?.profilePicture ? (
              <img className="emp-files__avatar" src={data.data.profilePicture} alt="" />
            ) : (
              <span className="emp-files__avatar" aria-hidden>
                {initials}
              </span>
            )}
            <div className="emp-files__title">
              <h1>Files</h1>
              <p>{employeeName || 'My documents'}</p>
            </div>
          </div>
          <div className="emp-files__meter">
            <strong>
              {documentsOnFile}
              <span>/{DOCUMENTS.length}</span>
            </strong>
            <small>documents on file</small>
            <div className="emp-files__meter-track" aria-hidden>
              <span style={{ width: `${(documentsOnFile / DOCUMENTS.length) * 100}%` }} />
            </div>
          </div>
        </header>

        <section className="emp-files__section">
          <div className="emp-files__section-head">
            <h2>Documents</h2>
            <p>Identity, education, and previous company letters.</p>
          </div>
          <div className="emp-files__grid">
            {DOCUMENTS.map((doc) => {
              const items = state[doc.key] || [];
              const savedCount = items.filter((item) => !(item instanceof File)).length;
              const pending = items.filter((item) => item instanceof File);
              const status = pending.length ? 'pending' : savedCount ? 'done' : 'empty';
              const statusLabel = pending.length ? 'Unsaved' : savedCount ? 'On file' : 'Empty';

              return (
                <article className={`emp-files__card is-${status}`} key={doc.key}>
                  <div className="emp-files__card-head">
                    <span className={`emp-files__icon emp-files__icon--${doc.tone}`} aria-hidden>
                      <i className={doc.icon} />
                    </span>
                    <div className="emp-files__card-copy">
                      <h3>{doc.label}</h3>
                      <p>
                        {pending.length
                          ? `${pending.length} ready to save`
                          : savedCount
                            ? `${savedCount} file${savedCount > 1 ? 's' : ''}`
                            : 'PDF or image'}
                      </p>
                    </div>
                    <span className={`emp-files__status emp-files__status--${status}`}>
                      {statusLabel}
                    </span>
                  </div>

                  {renderPreview(items, doc.key)}

                  <label className="emp-files__picker">
                    <input
                      type="file"
                      multiple
                      ref={state[`${doc.key}Ref`]}
                      onChange={(e) => handleUploadFile(e, doc.key)}
                      accept="application/pdf, image/*"
                      aria-label={`Upload ${doc.label}`}
                    />
                    <span className="emp-files__picker-icon" aria-hidden>
                      <i className="bi bi-cloud-arrow-up" />
                    </span>
                    <span className="emp-files__picker-copy">
                      <strong>
                        {pending.length
                          ? pending.map((file) => file.name).join(', ')
                          : 'Upload files'}
                      </strong>
                      <small>PDF, JPG, or PNG</small>
                    </span>
                  </label>

                  {state?.[doc.key]?.some((item) => item instanceof File) ? (
                    <button
                      type="button"
                      className="emp-files__save"
                      onClick={() => handleSubmitUploadS3(doc.key)}
                      disabled={loading[doc.key]}
                    >
                      {loading[doc.key] ? (
                        LOADING
                      ) : (
                        <>
                          <i className="bi bi-check2" aria-hidden /> Save
                        </>
                      )}
                    </button>
                  ) : null}
                </article>
              );
            })}
          </div>
        </section>

        <section className="emp-files__library">
          <div className="emp-files__section-head">
            <h2>Other files</h2>
            <p>Anything that does not belong in the documents above.</p>
          </div>
          <div className="emp-files__toolbar">
            <label className="emp-files__field">
              <span>Search</span>
              <input
                className="emp-files__input"
                placeholder={PH_SEARCH_INPUT}
                onChange={(e) => debouncedOnSearchData(e.target.value)}
                aria-label="Search files"
              />
            </label>
            <label className="emp-files__picker emp-files__picker--toolbar">
              <input
                type="file"
                multiple
                ref={state.filesRef}
                onChange={(e) => handleUploadFile(e, 'files')}
                aria-label="Add other files"
              />
              <span className="emp-files__picker-icon" aria-hidden>
                <i className="bi bi-plus-lg" />
              </span>
              <span className="emp-files__picker-copy">
                <strong>
                  {otherPending.length
                    ? otherPending.map((file) => file.name).join(', ')
                    : 'Add files'}
                </strong>
                <small>{otherPending.length ? 'Not saved yet' : 'Any file type'}</small>
              </span>
            </label>
            <button
              type="button"
              className="emp-files__save"
              disabled={state?.files?.length === 0 || otherFileUploadLoading}
              onClick={handleSave}
            >
              {otherFileUploadLoading ? LOADING : BTN_SAVE}
            </button>
          </div>

          {isLoading || isFetching ? (
            <div className="emp-files__panel">
              <ListSkeleton rows={5} />
            </div>
          ) : fileListData?.data?.length > 0 ? (
            <ul className="emp-files__list">
              {fileListData.data.map((item, itemIndex) => (
                <React.Fragment key={itemIndex}>
                  {item?.hrxFiles?.length > 0 ? (
                    item.hrxFiles.map((file, fileIndex) => (
                      <li className="emp-files__file" key={`${itemIndex}-${fileIndex}`}>
                        <div className="emp-files__file-main">
                          <span className="emp-files__file-thumb">
                            {file?.url && isImage(file.url) ? (
                              <img src={file.url} alt="" />
                            ) : (
                              getFileIconS3Url(file?.url)
                            )}
                          </span>
                          <span className="emp-files__file-copy">
                            <strong>{file?.fileName?.split('/').pop()}</strong>
                            <small>
                              {LB_ADDED_BY} {file?.createdBy?.name}
                            </small>
                          </span>
                        </div>
                        <span className="emp-files__size">{formatFileSize(file?.size)}</span>
                        <div className="emp-files__file-actions">
                          <button
                            type="button"
                            className="emp-files__icon-btn"
                            onClick={() => downloadFile(file)}
                            aria-label="Download"
                          >
                            <i className="bi bi-download" aria-hidden />
                          </button>
                          <button
                            type="button"
                            className="emp-files__icon-btn emp-files__icon-btn--danger"
                            onClick={() => handleDelete(file?._id)}
                            aria-label="Delete"
                          >
                            <i className="bi bi-trash" aria-hidden />
                          </button>
                        </div>
                      </li>
                    ))
                  ) : (
                    <li className="emp-files__empty">{NO_FILES_AVAILABLE}</li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          ) : (
            <div className="emp-files__empty-state">
              <img src={NoFilesFound} alt="" />
              <h3>{PH_NO_FILES}</h3>
            </div>
          )}
        </section>
      </div>

      <ConfirmDialog
        show={state.showDeleteModal}
        onHide={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        variant="danger"
        icon="icofont-ui-delete"
        title={DELETE_FILE}
        message={DELETE_CONFIRM}
        confirmLabel={BTN_DELETE}
        cancelLabel={BTN_CANCEL}
      />
    </>
  );
}

// import React, { useState, useEffect } from 'react';
// import _debounce from 'lodash/debounce';

// import NoFilesFound from '../../assets/images/noFilesFound.svg';

// import PageHeader from '../../components/common/PageHeader';

// import { useIsLoggedInQuery } from '../../redux/apis/authApi';
// import { useGetFileListQuery } from '../../redux/apis/files';

// import { PLACEHOLDER } from '../../utils/constant/placeHolders';
// import { downloadFile, getFileIcon, isImage } from '../../utils/handler';
// import { GLOBAL } from '../../utils/constant/global';
// import { LB_FILES } from '../../utils/constant/labels';

// const { PH_SEARCH_INPUT, PH_NO_FILES } = PLACEHOLDER;
// const { LB_ADDED_BY } = LB_FILES;
// const { LOADING } = GLOBAL;

// const initialState = {
//   search: ''
// };

// export default function EmployeeFile() {
//   const [state, setState] = useState(initialState);

//   const { data } = useIsLoggedInQuery();

//   const {
//     data: fileListData,
//     isLoading,
//     isFetching,
//     refetch
//   } = useGetFileListQuery({
//     userId: data.data._id,
//     search: state.search
//   });

//   useEffect(() => {
//     // fileListFetch();
//     refetch();
//   }, [data.data._id]);

//   function formatFileSize(bytes) {
//     if (bytes === 0) return '0 Bytes';

//     const k = 1024;
//     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
//     const i = Math.floor(Math.log(bytes) / Math.log(k));

//     return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//   }

//   const debouncedOnSearchData = _debounce((data) => {
//     setState({ ...state, search: data });
//   }, 500);

//   return (
//     <div className="container-xxl">
//       <PageHeader headerTitle="Files" />
//       <div className="row clearfix g-3">
//         <div className="mb-4">
//           <input
//             className="form-control"
//             placeholder={PH_SEARCH_INPUT}
//             onChange={(e) => {
//               debouncedOnSearchData(e.target.value);
//             }}
//           />
//         </div>
//         <div className="card">
//           <div className="card-body">
//             <ul className="list-group">
//               {isLoading || isFetching ? (
//                 <div
//                   className="loading-card"
//                   style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     height: '100%'
//                   }}
//                 >
//                   <div class="spinner-border" role="status" style={{ margin: '0 auto' }}>
//                     <span class="visually-hidden">{LOADING}</span>
//                   </div>
//                 </div>
//               ) : fileListData?.data?.length > 0 ? (
//                 fileListData?.data.map((item, itemIndex) => {
//                   return (
//                     <>
//                       {item?.hrxFiles?.length > 0 ? (
//                         item?.hrxFiles.map((file, fileIndex) => (
//                           <li
//                             key={`${itemIndex}-${fileIndex}`}
//                             className="list-group-item d-flex justify-content-between align-items-center"
//                           >
//                             <div
//                               style={{
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 marginBottom: '10px'
//                               }}
//                             >
//                               <div style={{ marginRight: '10px', width: '70px', height: '70px' }}>
//                                 {file?.url && isImage(file.url) ? (
//                                   // Show the image if the file is an image type
//                                   <img src={file?.url} alt="File" width={70} height={70} />
//                                 ) : (
//                                   // Show the file icon if it's not an image
//                                   getFileIcon(file?.url)
//                                 )}
//                               </div>
//                               <div>
//                                 <span>{file?.fileName}</span>
//                                 <br />
//                                 <small>
//                                   {LB_ADDED_BY} {file?.createdBy?.name}
//                                 </small>
//                                 <br />
//                                 <span> - {formatFileSize(file?.size)}</span>
//                               </div>
//                             </div>
//                             <div className="d-flex align-items-center">
//                               <div className="ml-3">
//                                 <button
//                                   type="button"
//                                   className="btn btn-primary"
//                                   onClick={() => downloadFile(file)}
//                                 >
//                                   <i className="icofont-download"></i>
//                                 </button>
//                               </div>
//                             </div>
//                           </li>
//                         ))
//                       ) : (
//                         <li className="list-group-item">No files available</li>
//                       )}
//                     </>
//                   );
//                 })
//               ) : (
//                 <div
//                   style={{
//                     width: '100%',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     flexDirection: 'column',
//                     rowGap: '19px'
//                   }}
//                 >
//                   <img src={NoFilesFound} alt="No files" />
//                   <h5
//                     style={{
//                       color: '#b3a8a8'
//                     }}
//                   >
//                     {PH_NO_FILES}
//                   </h5>
//                 </div>
//               )}
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
